export default {
  globalTableData: [],
  selectedTab: 0,
  //actions panel related
  globalSelectedRows: [],
  globalApprovedRows: [], //[{tabID:number, approvedRows: arrayOF(objects), isAllApproved: boolean}]
  selectedActionData: {}
};
